import type { IAgent } from '@/store/types';

const getContractDisplayLabel = (agent: IAgent): string => {
  const jobName = agent.jobName ? `${agent.jobName} - ` : '';
  const clientName = agent.clientName ? `${agent.clientName} - ` : '';
  return `${clientName}${jobName}${agent.contractName}`;
};

export { getContractDisplayLabel };
